import React from 'react';
import { Container, Button } from 'react-bootstrap';

function HeroSection() {
  return (
    <div className="hero-section position-relative" style={{ 
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0078D4 0%, #1E3A8A 50%, #0B1F3F 100%)',
      overflow: 'hidden'
    }}>
      {/* Background Image - Desktop */}
      <div 
        className="hero-image-container position-absolute w-100 h-100 d-none d-md-block"
        style={{
          backgroundImage: 'url(/images/hero-img.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          opacity: '0.85'
        }}
      />
      {/* Background Image - Mobile: cover, pozycja żeby widać twarz i rękę */}
      <div 
        className="hero-image-container position-absolute w-100 h-100 d-md-none"
        style={{
          backgroundImage: 'url(/images/hero-img.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: '70% 60%',
          backgroundRepeat: 'no-repeat',
          opacity: '0.9'
        }}
      />
      
      {/* Gradient Overlay - Desktop: from left */}
      <div 
        className="position-absolute w-100 h-100 d-none d-md-block"
        style={{
          background: 'linear-gradient(to right, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 50%, rgba(0,0,0,0.1) 100%)'
        }}
      />
      {/* Gradient Overlay - Mobile: od góry i środka dla czytelności */}
      <div 
        className="position-absolute w-100 h-100 d-md-none"
        style={{
          background: 'linear-gradient(to bottom, rgba(0,30,70,0.85) 0%, rgba(0,20,50,0.3) 30%, transparent 50%, rgba(0,0,0,0.4) 75%, rgba(0,0,0,0.6) 100%)'
        }}
      />

      {/* Content - Positioned to float above hand */}
      {/* Desktop Container */}
      <Container className="position-relative h-100 d-none d-md-block" style={{ minHeight: '100vh' }}>
        <div 
          className="hero-content d-flex flex-column text-md-start"
          style={{ 
            paddingTop: '20vh',
            paddingLeft: '0',
            paddingRight: '0',
            maxWidth: '100%'
          }}
        >
          {/* Animated Badge */}
          <div className="mb-3 mb-md-4 animate-slide-down">
            <span 
              className="badge px-3 px-md-4 py-2" 
              style={{ 
                background: 'rgba(255,255,255,0.15)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255,255,255,0.3)',
                color: '#fff',
                fontSize: 'clamp(0.75rem, 2vw, 0.9rem)',
                fontWeight: '500',
                letterSpacing: '1px'
              }}
            >
              ☁️ AZURE DEVOPS ENGINEER
            </span>
          </div>

          {/* Main Heading */}
          <h1 
            className="fw-bold text-white mb-3 mb-md-4 animate-slide-up"
            style={{ 
              textShadow: '2px 4px 8px rgba(0,0,0,0.5)',
              lineHeight: '1.2',
              fontSize: 'clamp(2rem, 8vw, 4.5rem)'
            }}
          >
            <span style={{ color: '#60A5FA' }}>Cloud Solutions</span>
          </h1>

          {/* Subtitle */}
          <h2 
            className="fw-bold text-white mb-4 mb-md-5 animate-fade-in"
            style={{ 
              textShadow: '1px 2px 4px rgba(0,0,0,0.5)',
              fontSize: 'clamp(1.5rem, 6vw, 3rem)'
            }}
          >
            Beniamin Kwak
          </h2>

          {/* CTA Buttons */}
          <div className="d-flex flex-sm-row flex-wrap gap-3 mb-4 animate-fade-in justify-content-md-start" style={{ animationDelay: '0.3s' }}>
            <Button 
              variant="outline-light"
              size="lg"
              className="fw-bold px-4 py-3 rounded-3 btn-hover-lift"
              href="https://www.linkedin.com/in/beniaminkwak/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                backdropFilter: 'blur(10px)',
                background: 'rgba(255,255,255,0.1)',
                border: '2px solid rgba(255,255,255,0.5)',
                transition: 'all 0.3s ease',
                fontSize: 'clamp(0.9rem, 2vw, 1.1rem)'
              }}
            >
              <i className="bi bi-linkedin me-2"></i> LinkedIn
            </Button>
          </div>

          {/* Scroll Indicator */}
          <div className="scroll-indicator animate-bounce mt-5">
            <i className="bi bi-chevron-down text-white" style={{ fontSize: '2rem', opacity: '0.7' }}></i>
          </div>
        </div>
      </Container>

      {/* Mobile Container - tekst u góry, przyciski po lewej na wysokości głowy */}
      <Container className="position-relative d-md-none d-flex flex-column" style={{ minHeight: '100vh', paddingTop: '4vh', paddingBottom: '4vh' }}>
        {/* Górna część - tekst */}
        <div className="text-center">
          {/* Animated Badge */}
          <div className="mb-2 animate-slide-down">
            <span 
              className="badge px-2 py-1" 
              style={{ 
                background: 'rgba(255,255,255,0.2)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255,255,255,0.3)',
                color: '#fff',
                fontSize: '0.7rem',
                fontWeight: '500',
                letterSpacing: '1px'
              }}
            >
              ☁️ AZURE DEVOPS ENGINEER
            </span>
          </div>

          {/* Main Heading */}
          <h1 
            className="fw-bold text-white mb-1 animate-slide-up"
            style={{ 
              textShadow: '2px 4px 12px rgba(0,0,0,0.8)',
              lineHeight: '1.1',
              fontSize: '2rem'
            }}
          >
            <span style={{ color: '#60A5FA' }}>Cloud Solutions</span>
          </h1>

          {/* Subtitle */}
          <h2 
            className="fw-bold text-white mb-0 animate-fade-in"
            style={{ 
              textShadow: '1px 2px 8px rgba(0,0,0,0.8)',
              fontSize: '1.4rem'
            }}
          >
            Beniamin Kwak
          </h2>
        </div>

        {/* Przyciski po lewej stronie - na wysokości głowy */}
        <div 
          className="position-absolute animate-fade-in"
          style={{ 
            animationDelay: '0.3s',
            left: '25px',
            top: '35%'
          }}
        >
          <div className="d-flex flex-column gap-2">
            <Button 
              variant="outline-light"
              size="sm"
              className="fw-semibold px-2 py-1 rounded-2 btn-hover-lift"
              href="https://www.linkedin.com/in/beniaminkwak/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                backdropFilter: 'blur(10px)',
                background: 'rgba(255,255,255,0.15)',
                border: '1px solid rgba(255,255,255,0.5)',
                transition: 'all 0.3s ease',
                fontSize: '0.75rem'
              }}
            >
              LinkedIn
            </Button>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default HeroSection;